__turbopack_context__.v({
  "className": "questrial_f4907f48-module__y5cgLa__className",
});
